(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener("click", (e) => {
    // only if the click came from inside the footer
    const footer = document.querySelector("footer");
    if (!footer) return;

    const link = e.target.closest('a[href="/pages/help"], a[href="/pages/customer-support"]');
    if (!link || !footer.contains(link)) return;

    const text = link.textContent.trim();
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set("scroll", text);
    link.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const checkbox = document.getElementById('termsCheckbox');
    const errorMsg = document.getElementById('termsError');
    const checkoutBtn = document.getElementById('checkout');

    console.log("Checkbox functionality loaded.");

    // Exit if elements don't exist
    if (!checkbox || !checkoutBtn) return;

    checkoutBtn.addEventListener('click', function(e) {
      if (!checkbox.checked) {
        e.preventDefault();
        errorMsg.style.display = 'block';
        return;
      }

      errorMsg.style.display = 'none';
      window.location.href = '/checkout';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Find the 'In stock' availability filter
    const inStockCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]');

    // Check if the filter exists
    if (inStockCheckbox && !inStockCheckbox.checked) {
      // Mark it as checked
      inStockCheckbox.checked = true;

      // Optional: automatically trigger a filter update if your theme uses AJAX filtering
      const form = inStockCheckbox.closest('form');
      if (form) {
        form.dispatchEvent(new Event('input', { bubbles: true })); // triggers auto-refresh
      } else {
        // If your theme uses URL-based filtering
        const url = new URL(window.location.href);
        url.searchParams.set('filter.v.availability', '1');
        window.location.href = url.toString(); // reload with the filter applied
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
